import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nextspace',
  templateUrl: './nextspace.component.html',
  styleUrls: ['./nextspace.component.scss']
})
export class NextspaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
